<template>
  <nav class="nav" v-if="routeLayout.isNav || isLoad">
    <button class="nav-icon" :class="currentURL === NAV_URL().HOME ? 'on' : ''" @click="fnMove(NAV_URL().HOME)">
      <img class="nav-img" :src="navHome" alt="" />
      <span class="ttl">홈</span>
    </button>
    <button class="nav-icon" :class="currentURL === NAV_URL().SEARCH ? 'on' : ''" @click="$router.push('/business')">
      <img class="nav-img" :src="navExplore" alt="" />
      <span class="ttl">탐색</span>
    </button>

    <button
      class="nav-icon more-btn"
      :class="isFloating ? 'on' : ''"
      @click="store.commit('layout/setIsFloating', !isFloating)"
    >
      <span class="round">
        <!-- 260609: 공유 아이콘 — 시안 제공 에셋(share-03) 그대로 사용 -->
        <img v-if="!isFloating" :src="fabShare" class="fab-ico fab-ico--img" alt="공유" />
        <!-- 플로팅 열림 시 닫기(X) — 260612 공유 리뉴얼: 검정(Figma cancel-01) -->
        <svg v-else class="fab-ico" viewBox="0 0 24 24" fill="none" stroke="#000" stroke-width="2.4" stroke-linecap="round" aria-hidden="true">
          <path d="M6 6l12 12M18 6 6 18" />
        </svg>
      </span>
    </button>

    <!-- 260424 오후 회의: 다이어리 → 내 비즈니스 관리 교체. 260609 리뉴얼: 라벨 '나의 간판' -->
    <button class="nav-icon" :class="currentURL === '/business/my' ? 'on' : ''" @click="fnMyBusiness()">
      <img class="nav-img" :src="navSignboard" alt="" />
      <span class="ttl">나의 간판</span>
    </button>
    <button class="nav-icon " :class="moreClass" @click="fnMove(NAV_URL().MORE)">
      <img class="nav-img" :src="navMy" alt="" />
      <span class="ttl">마이</span>
    </button>
  </nav>
</template>

<script setup>
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { computed } from 'vue';
import { NAV_URL } from '@/common/constants/ConstCode';
import router from '@/router';
import store from '@/store';
import { isEmpty } from '@/common/utils/Util';
import { modalList, show, showTextModal } from '@/common/utils/ModalState';
// 260609 리뉴얼: 하단 네비 아이콘 (흰 라인 → CSS filter로 회색/초록 렌더)
import navHome from '@/assets/static/images/renewal/nav-home.svg';
import navExplore from '@/assets/static/images/renewal/nav-explore.png';
import navSignboard from '@/assets/static/images/renewal/nav-signboard.png';
import navMy from '@/assets/static/images/renewal/nav-my.png';
// 260609: FAB 공유 아이콘 — 시안 제공 에셋
import fabShare from '@/assets/static/images/renewal/fab-share.png';

const { getters } = useStore();
const { push, replace } = useRouter();
const route = useRoute();

const props = defineProps({
  isLoad: {
    type: Boolean,
    default: false
  }
});

const currentRoute = computed(() => {
  if (route.path.includes('business'))  {
    store.commit('layout/setIsBackFromSearch', false);
  }
  return null;
});

const user = computed(() => store.getters['user/getUserData']);
const currentURL = computed(() => router.currentRoute.value.path);
const isFloating = computed(() => store.getters['layout/getIsFloating']);
const isHamburger = computed(() => store.getters['layout/getIsHamburger']);

const openHamburger = () => {
  store.commit('layout/setIsHamburger', !isHamburger.value);
};
const routeLayout = computed(() => {
  return getters['layout/getRouteLayout'];
});

const moreClass = computed(() => {
  let innerClass = '';
  if (user.value.userNo && !user.value.isRead) innerClass += 'essen ';
  if (currentURL.value === NAV_URL().MORE) innerClass += 'on ';
  return innerClass;
});

const fnMove = async url => {
  // 같은 탭 재탭 → 그 화면 최상단으로 스크롤 (홈). router.push는 중복 이동이라 무시되므로 여기서 처리.
  if (router.currentRoute.value.path === url) {
    if (url === NAV_URL().HOME) {
      document.querySelector('.main .inner')?.scrollTo({ top: 0, behavior: 'smooth' });
    }
    return;
  }
  if (isEmpty(user.value.userNo) && (url.includes('/welldying') || url.includes('/more'))) {
    showTextModal('로그인 후 이용가능합니다.', '확인', () => {
      router.push('/signin');
    });
    return;
  }
  await router.push(url);
};


const fnSearch = async url => {
  if (isEmpty(user.value.userNo) && (url.includes('/welldying') || url.includes('/more'))) {
    showTextModal('로그인 후 이용가능합니다.', '확인', () => {
      router.push('/signin');
    });
  }
  await router.push(url);
};

const fnShowWellPasswordInput = () => {
  if (route.path === '/welldying') return;
  if (!user.value.hasWellPassword) {
    fnMove('/setting/welldying/password');
    return;
  }
  show(modalList.WELL_PASSWORD_MODAL, { title: '웰다잉 비밀번호 입력' });
  // fnMove(`/welldying?title=${user.value.name}님`);
};

const fnMyBusiness = () => {
  if (isEmpty(user.value.userNo)) {
    showTextModal('로그인 후 이용가능합니다.', '확인', () => {
      router.push(`/signin`);
    });
    return;
  }
  router.push(`/business/my`);
};
</script>

<style scoped>
/* 260609 리뉴얼: 검은 푸터(시안) + 라인 아이콘(비활성 라이트그레이 / 활성 그린) */
.nav {
  background: #0d0d0d !important;
  box-shadow: 0 -0.1rem 0 rgba(255, 255, 255, 0.06) !important;
}
/* FAB 뒤 흰 알약(pill) 제거 + 네비 상단에 반쯤 걸치게 위로 띄움(시안) */
.nav-icon.more-btn {
  background: transparent !important;
  border-top: 0 !important;
  transform: translateY(-1.4rem);
}
.nav-img {
  display: block;
  width: 2.4rem;
  height: 2.4rem;
  margin: 0 auto;
  object-fit: contain;
  /* 검은 푸터 위 — 흰 실루엣 후 반투명으로 라이트그레이 */
  filter: brightness(0) invert(1);
  opacity: 0.45;
  transition: opacity 0.15s, filter 0.15s;
}
:deep(.nav-icon.on) .nav-img {
  opacity: 1;
  /* 밝은 그린(#2ed94a 근사) */
  filter: brightness(0) saturate(100%) invert(64%) sepia(64%) saturate(442%) hue-rotate(74deg) brightness(101%) contrast(89%);
}
/* 라벨 — 비활성 라이트그레이 / 활성 그린 */
.nav-icon .ttl { color: #9aa0a6 !important; }
:deep(.nav-icon.on) .ttl { color: #2ed94a !important; }

/* 공유 FAB — 밝은 초록 원 + 흰 인라인 SVG share 아이콘 */
.nav-icon.more-btn .round {
  /* 시안: #44DC36 + 0.4 헤일로 링 */
  background: #44dc36 !important;
  border: 0 !important;
  box-shadow: 0 0 0 0.4rem rgba(68, 220, 54, 0.4), 0 0.3rem 0.9rem rgba(68, 220, 54, 0.45) !important;
}
.nav-icon.more-btn .round .fab-ico {
  width: 2.7rem;
  height: 2.7rem;
  display: block;
}
/* 시안 제공 share 에셋 — 원래 색(검정) 그대로 */
.nav-icon.more-btn .round .fab-ico--img {
  object-fit: contain;
}

.hamburger-icon {
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  gap: 4px;
  width: 22px;
  height: 18px;
  margin: 0 auto;
}
.hamburger-icon span {
  display: block;
  width: 100%;
  height: 2px;
  background: currentColor;
  border-radius: 2px;
}

/* 공유하기 버튼 — 잘림 방지 + 골프존 비율로 축소 (260420) */
.nav {
  position: relative;
  z-index: 9999;
  overflow: visible;
}
:deep(.nav-icon.more-btn) {
  min-height: 5.2rem !important;
  padding: 0.4rem 0.4rem 0.8rem !important;
}
:deep(.nav-icon.more-btn .round) {
  width: 4.4rem !important;
  height: 4.4rem !important;
  position: relative;
  z-index: 1;
}
:deep(.nav-icon.more-btn .round .ico-round-icon) {
  width: 2.6rem !important;
  height: 2.6rem !important;
}
</style>
